import { ContentSearchDataOfContentSearchHit, ParticaStoreClient, IParticaStoreClient, ArticleModel, StoreArticleDTO, IMyPurchasedArticlesClient, MyPurchasedArticlesClient, StoreArticleDTOArticleType, ArticleModelArticleType, CustomerArticleLicenceDTO } from "@/Generated/ParticaAPI";
import { ArticleUtils } from "./articleutils";
import { IArticle, Article, ArticleImage } from "@/Models/ArticleModels/article";

export interface IParticaStoreService {
	searchArticles(data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit>;
	getStreamArticle(articleId: string): Promise<IArticle>;
	getPurchasedArticles(accountId: number): Promise<IArticle[]>;
	getPurchasedArticle(articleId: string): Promise<IArticle>;
	savePurchasedArticle(article: IArticle): Promise<IArticle>;
	getStoreArticles(accountId: number): Promise<IArticle[]>;
	getArticleLicence(articelId: string): Promise<CustomerArticleLicenceDTO>;
	getCurrentArticleLicence(articelId: string): Promise<CustomerArticleLicenceDTO>;
}

export class ParticaStoreService implements IParticaStoreService {
	private svc: IParticaStoreClient = new ParticaStoreClient();
	private purchasedClient: IMyPurchasedArticlesClient = new MyPurchasedArticlesClient();
	private utils: ArticleUtils = new ArticleUtils();

	public async getArticleLicence(articelId: string): Promise<CustomerArticleLicenceDTO> {
		let licence = await this.svc.getArticleLicence(articelId);
		if (Object.keys(licence).length === 0) {
			licence = new CustomerArticleLicenceDTO();
			licence.name = "Default Licence";
			licence.body = "No licence is assigned to this article. The default Partica licence should be assumed.";
		}
		return licence;
	}

	public async getCurrentArticleLicence(articelId: string): Promise<CustomerArticleLicenceDTO> {
		let licence = await this.svc.getCurrentArticleLicence(articelId);
		if (Object.keys(licence).length === 0) {
			licence = new CustomerArticleLicenceDTO();
			licence.name = "Default Licence";
			licence.body = "No licence is assigned to this article. The default Partica licence should be assumed.";
		}
		return licence;
	}

	public async searchArticles(data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit> {
		return await this.svc.searchStore(data);
	}
	public async getStreamArticle(articleId: string): Promise<IArticle> {
		const am: ArticleModel = await this.svc.getContentStreamArticle(articleId);
		return this.utils.convertarticle<IArticle>(am);
	}
	public async getPurchasedArticle(articleId: string): Promise<IArticle> {
		const am: ArticleModel = await this.svc.getPurchasedArticle(articleId);
		return this.utils.convertarticle<IArticle>(am);
	}
	public async savePurchasedArticle(article: IArticle): Promise<IArticle> {
		let a: ArticleModel = article.get<ArticleModel>();
		a = await this.purchasedClient.saveArticle(a);
		return this.utils.convertarticle<IArticle>(a);
	}

	public async getPurchasedArticles(accountId: number): Promise<IArticle[]> {
		const articles: IArticle[] = [];
		const sa: { [key: string]: StoreArticleDTO[] } = await this.svc.getArticles(accountId);
		// @ts-ignore
		if (sa["MyArticles"]) {
			// @ts-ignore
			const tmparticles = sa["MyArticles"];
			tmparticles.forEach(a => {
				const t: IArticle = new Article();
				t.title = a.title as string;
				t.abstract = a.abstract as string;
				t.articleId = a.articleId;
				t.issue.guid = a.issueGuid as string;
				if (a.images !== undefined) {
					a.images.forEach(i => {
						const img: ArticleImage = new ArticleImage();
						img.isFeatured = i.isFeatured as boolean;
						img.src = i.src as string;
						t.images.push(img);
					});
				}
				articles.push(t);
			});
		}
		return articles;
	}

	public async getStoreArticles(accountId: number): Promise<IArticle[]> {
		const articles: IArticle[] = [];
		const sa: { [key: string]: StoreArticleDTO[] } = await this.svc.getArticles(accountId);
		for (const key in sa) {
			if (sa.hasOwnProperty(key)) {
				const pub = sa[key];
				pub.forEach(a => {
					const t: IArticle = new Article();
					t.id = a.id as number;
					t.title = a.title as string;
					t.abstract = a.abstract as string;
					t.articleId = a.articleId;
					t.articleType = a.articleType as unknown as ArticleModelArticleType;
					t.issue.guid = a.issueGuid as string;
					t.issue.pubname = a.publication as string;
					t.articleDate = a.added as Date;
					if (a.images !== undefined) {
						a.images.forEach(i => {
							const img: ArticleImage = new ArticleImage();
							img.isFeatured = i.isFeatured as boolean;
							img.src = i.src as string;
							t.images.push(img);
						});
					}
					articles.push(t);
				});
			}
		}
		return articles;
	}

}
